import { isString } from 'lodash';
import { ReactNode } from 'react';
import { Text } from '@shared/components/Text';
import { View, ViewProps } from '@shared/components/View';
import styles from './MenuSection.module.css';

/**
 * MenuSection
 *
 * A section of a menu. Use this to render arbitrary content within a menu, with
 * the same padding as MenuItem. (Don't put MenuItems in a MenuSection.)
 * The title stays on one line and truncates. `titleEnd` sits across from it, at the end of the same
 * line; a string is styled like the title.
 */

interface MenuSectionProps extends ViewProps {
  title?: string;
  titleEnd?: ReactNode;
}

export function MenuSection({ children, title, titleEnd, className, ...rest }: MenuSectionProps) {
  const titleText = title && (
    <Text size="overline" weight="semibold" numberOfLines={1} className={styles.menuSectionTitle}>
      {title}
    </Text>
  );
  return (
    <View className={[styles.menuSection, className]} {...rest}>
      {titleEnd ? (
        <div className={styles.menuSectionHeader}>
          {titleText}
          <div className={styles.menuSectionTitleEnd}>
            {isString(titleEnd) ? (
              <Text size="overline" weight="semibold">
                {titleEnd}
              </Text>
            ) : (
              titleEnd
            )}
          </div>
        </div>
      ) : (
        titleText
      )}
      {children}
    </View>
  );
}
